import React from 'react';
import styles from './MultiSwitch.module.scss';
import cn from 'classnames';
import _ from 'lodash';

export default function MultiSwitch({options, className, onChange, value, label, name, onChangeField, disabled}) {
    const handleChange = value => {
        onChange(value);
        onChangeField({target: {name, value}});
    };
    const switcherWrapper = cn(styles.multiSwitch, className, {[styles.disabled]: disabled});
    let len = Object.keys(options).length;

    let optionIndex = options.findIndex(option => option.value === value);
    if (optionIndex === -1) {
        optionIndex = options.length - 1;
    }
    let calculateTrackPosition = (optionIndex / len) * 100;
    if (calculateTrackPosition === 0) calculateTrackPosition = -1;
    if (calculateTrackPosition >= 100 - 100 / len) calculateTrackPosition += 1;
    const trackStyle = {left: `${calculateTrackPosition}%`, '--track-size': `${100 / len}%`};

    return (
        <div className={switcherWrapper}>
            <div className={styles.label}>{label}</div>
            <div className={styles.switch}>
                <div className={styles.track} style={trackStyle}>
                    {options[optionIndex].label}
                </div>
                {options.map(option => {
                    return (
                        <div className={styles.option} onClick={() => handleChange(option.value)} key={option.label}>
                            {option.label}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

MultiSwitch.defaultProps = {
    onChange: _.noop,
    onChangeField: _.noop,
};
